import Vue from "vue";
import VueRouter from "vue-router";
import Crew from "../views/CrewDispatch.vue";

Vue.use(VueRouter);

const routes = [{
  path: "/",
  name: "Crew",
  component: Crew
}];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
